import { render, staticRenderFns } from "./_resupply.tab.vue?vue&type=template&id=fdd8b930&scoped=true"
import script from "./_resupply.tab.vue?vue&type=script&lang=js"
export * from "./_resupply.tab.vue?vue&type=script&lang=js"
import style0 from "./_resupply.tab.vue?vue&type=style&index=0&id=fdd8b930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd8b930",
  null
  
)

export default component.exports